import { toast } from "sonner";
import { formatErr } from "@/lib/api";
import { dapi as api } from "./deskApi";

// Swaps a file with its version from before the last save (doing it again swaps back).
export const restorePrevious = async (node, onDone) => {
  if (!window.confirm(`Restore "${node.name}" to the version before its last save? You can undo this the same way.`)) return;
  try {
    await api.post(`/desktop/fs/${node.id}/restore-previous`);
    toast.success(`"${node.name}" restored to its previous version.`);
    onDone?.();
  } catch (error) {
    toast.error(formatErr(error.response?.data?.detail) || "Couldn't restore the previous version.");
  }
};
